document.addEventListener('DOMContentLoaded', function() {
  const ctaElement = document.querySelector('.collection-scroll-cta');
  if (!ctaElement) return;
  
  // Check if this is a returning visitor (has a previous session stored)
  const hasVisitedBefore = localStorage.getItem('gcc_has_visited');
  const isFirstSession = sessionStorage.getItem('gcc_first_session');
  
  // If first session flag exists, we're in the first session - HIDE the CTA
  if (isFirstSession) {
    ctaElement.style.display = 'none';
    return;
  }
  
  // No first session flag means this is a new session
  // Check if they've visited before
  if (!hasVisitedBefore) {
    // First time ever - mark both flags and hide CTA
    sessionStorage.setItem('gcc_first_session', 'true');
    localStorage.setItem('gcc_has_visited', 'true');
    ctaElement.style.display = 'none';
  } else {
    // Returning visitor in a new session - show CTA
    ctaElement.style.display = '';
  }
});
